import { WebApi } from '@/services/WebApi'

const state = () => ({
  loadedPets: false,
  loadingPets: false,
  petCaches: []
})

const mutations = {
  setPets (state, pets) {
    state.petCaches = pets
    state.loadedPets = true
  },
  appendPet (state, pet) {
    const index = state.petCaches.findIndex(pc => pc.id === pet.id)
    if (index !== -1) {
      state.petCaches[index] = { ...pet }
    } else {
      state.petCaches.push({ ...pet })
    }
  },
  removePet (state, pet) {
    const index = state.petCaches.findIndex(pc => pc.id === pet.id)
    if (index !== -1) {
      state.petCaches.splice(index, 1)
    }
  },
  setLoading (state, value) {
    state.loadingPets = value
  }
}

const actions = {
  findPets ({ commit }, inviteId) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      WebApi.get('ClientOnboardingInvite/' + inviteId + '/Pet')
        .then(response => {
          commit('setPets', response.data)
          resolve(response)
        })
        .catch(error => reject(error))
        .finally(() => commit('setLoading', false))
    })
  },
  updatePet ({ commit }, { inviteId, payload }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      WebApi.put('ClientOnboardingInvite/' + inviteId + '/Pet', payload)
        .then(response => {
          commit('appendPet', response.data)
          resolve(response)
        })
        .catch(error => reject(error))
        .finally(() => commit('setLoading', false))
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
